import { FC } from 'react';
import {
  AccordionDetails,
  AccordionSummary,
  BareAccordion,
} from 'atoms/BareAccordion';
import { Icon, IconType } from 'atoms/Icon';
import { ISideBarAccordion } from './types';
import styles from './styles.module.css';

export const SidebarAccordion: FC<ISideBarAccordion> = ({
  children,
  summaryContent,
  summaryInlineStyle,
  ...accordionProps
}) => {
  return (
    <BareAccordion
      component="div"
      transition="none"
      classes={{
        root: styles.accordionRoot,
        expanded: styles.rootExpanded,
      }}
      {...accordionProps}
    >
      <AccordionSummary
        style={{ ...summaryInlineStyle }}
        classes={{
          root: styles.summaryRoot,
          content: styles.summaryContent,
          expandIconWrapper: styles.iconWrapper,
        }}
        expandIcon={<Icon type={IconType.arrowDown} className={styles.arrow} />}
      >
        {summaryContent}
      </AccordionSummary>
      <AccordionDetails classes={{ root: styles.detailsRoot }}>
        {children}
      </AccordionDetails>
    </BareAccordion>
  );
};
